import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import API from "../config/config";
import Loginleftimg from "../images/loginleft.png";
import LogoIcon from "../images/logo.png";

import Loader from "../components/Loader";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    console.log(email);
    e.preventDefault();
    try {
      setLoginLoading(true);
      const response = await axios.post(API.ADMIN.LOGIN, {
        emailId: email,
        password: password,
      });

      console.log(response);
      const { token } = response.data;

      // Save token in local storage or cookie
      localStorage.setItem("adminToken", token);
      // Show spinner for a moment before redirect
      setTimeout(() => {
        window.location.href = "/";
      }, 600);
    } catch (error) {
      setLoginLoading(false);
      setError("Invalid login credentials");
    }
  };

  return (
    <>
      {loginLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-white bg-opacity-80 z-50">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
          <div className="text-lg font-semibold text-blue-700">
            Logging in...
          </div>
        </div>
      )}
      <div
        className={`min-h-screen flex items-center justify-center bg-gray-100 `}
      >
        <div className="grid md:grid-cols-3 grid-cols-1 p-10 h-screen">
          <div className="md:col-span-2 bg-white rounded shadow-md w-full invisible md:visible">
            <img
              src={Loginleftimg}
              className="w-full h-full m-auto mb-2"
              alt="logo icon"
            />
          </div>
          <div className="bg-white p-4 rounded shadow-md w-full">
            <img
              src={LogoIcon}
              className="size-24 m-auto mb-3 mt-2"
              alt="logo icon"
            /> 
            <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            <form onSubmit={handleLogin}>
              <input
                type="email"
                className="w-full mb-6 p-2 border border-gray-300 rounded-3xl"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className="relative mb-6">
                <input
                  type={showPassword ? "text" : "password"}
                  className="w-full p-2 pr-10 border border-gray-300 rounded-3xl"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-gray-500 hover:text-gray-700 focus:outline-none"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FaEyeSlash className="w-4 h-4" /> : <FaEye className="w-4 h-4" />}
                </button>
              </div>
              <button className="w-full bg-blue-500 text-white p-2 rounded-3xl">
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
